import PropTypes from 'prop-types'
import { applySpec, identity, ifElse, isEmpty, join, pathOr, pipe } from 'ramda'
import broadcastUtils from '../../utils/broadcast'
import s3LinkParser from '../../utils/s3-link'
import BroadcastSeriesPreview, {
  BroadcastSeriesPreviewPropTypes,
} from './series-preview'

const url = ({ livdemyId, type, url: bcUrl, version }) =>
  `/${livdemyId}/${broadcastUtils.getByType(type)?.route}/${bcUrl}/${version}`

const BroadcastSingle = applySpec({
  id: pathOr('', ['id']),
  cover: pipe(pathOr('', ['coverImage', 'location']), s3LinkParser),
  coverVideo: pathOr('', ['profileVideo']),
  name: pathOr('', ['name']),
  description: pathOr('', ['description']),
  fee: pathOr(0, ['fee']),
  currency: pathOr('', ['currency']),
  discount: pathOr(0, ['discount']),
  startTime: pathOr(0, ['startTime']),
  endTime: pathOr(0, ['endTime']),
  type: pathOr('', ['type']),
  artist: pathOr('', ['teacher', 'userInfo', 'name']),
  artistId: pathOr('', ['teacher', 'id']),
  livdemyId: pathOr('', ['teacher', 'livdemyId']),
  difficulty: pathOr('beginner', ['difficulty']),
  medium: pipe(pathOr(['english'], ['medium']), join(', ')),
  url,
  series: pipe(
    pathOr({}, ['series']),
    ifElse(isEmpty, identity, BroadcastSeriesPreview),
  ),

  registration: applySpec({
    id: pathOr('', ['registrations', '0', 'id']),
    billId: pathOr('', ['registrations', '0', 'billId']),
    status: pathOr('UNREGISTERED', ['registrations', '0', 'status']),
  }),
  registrationOpen: pathOr(false, ['canRegister']),

  recording: applySpec({
    id: pathOr('', ['recordingId']),
    otp: pathOr('', ['videoInfo', 'otp']),
    playbackInfo: pathOr('', ['videoInfo', 'playbackInfo']),
  }),
})

export const BroadcastSinglePropTypes = PropTypes.shape({
  id: PropTypes.string.isRequired,
  cover: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  fee: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
  discount: PropTypes.number.isRequired,
  startTime: PropTypes.number.isRequired,
  endTime: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
  artist: PropTypes.string.isRequired,
  artistId: PropTypes.string.isRequired,
  artistCover: PropTypes.string.isRequired,
  livdemyId: PropTypes.string.isRequired,
  difficulty: PropTypes.string.isRequired,
  medium: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  registrationsOpen: PropTypes.bool.isRequired,
  series: BroadcastSeriesPreviewPropTypes,
})

export default BroadcastSingle
